const riesgo = [
    {label: "Riesgo Bajo", value: "Riesgo Bajo"},
    {label: "Riesgo Medio", value: "Riesgo Medio"},
    {label: "Riesgo Alto", value: "Riesgo Alto"}
]

export default riesgo;